import styled from "styled-components";
import { hexToRGBA } from "../../../utility/hexToRGB";
import { useTheme } from "../../../context/useThemeContext";

const TextDividerStyled = styled.div<{
    $borderColor: string;
    $textColor: string;
}>`
    font-size: 1rem;
    display: flex;
    align-items: center;
    color: ${(props) => props.$textColor};

    &::before,
    &::after {
        flex: 1;
        content: "";
        padding: 1px;
        background-color: ${(props) => props.$borderColor};
        margin: 0px;
    }
`;

export function TextDivider(props: { middleText: string }) {
    const { theme } = useTheme();

    return (
        <TextDividerStyled
            className="my-3"
            $borderColor={hexToRGBA(theme.fontColor[300], 0.4)}
            $textColor={theme.fontColor[200]}
        >
            <p className="mx-6 pb-1">{props.middleText}</p>
        </TextDividerStyled>
    );
}
